<template>
    <div>
        <router-link to="/directives/Intro">Intro</router-link>
      <br/>
        <router-link to="/directives/Exercise">Exercise</router-link>
    </div>
  <router-view />
</template>

<script setup lang="ts">
</script>
